export function useIsMobileView(mobileBreakpoint: string) {
    const isMobileView = ref(true);
    //This part was added to track screen size on SSR to avoid hydration errors
    const headers = useRequestHeaders();
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    if (import.meta.server) {
        isMobileView.value = headers?.['user-agent'] ? mobileRegex.test(headers?.['user-agent']) : true;
    }

    function checkIfMobileView() {
        if (import.meta.client) {
            const userAgent = navigator.userAgent;
            if (mobileRegex.test(userAgent)) {
                isMobileView.value = true;
            } else {
                isMobileView.value = !window.matchMedia(`(min-width: ${mobileBreakpoint})`).matches;
            }
        }
    }

    onBeforeMount(() => {
        checkIfMobileView();
    });

    onMounted(() => {
        window.addEventListener('resize', checkIfMobileView);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', checkIfMobileView);
    });

    return { isMobileView };
}
